import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";

import {MAP_STYLE_DEFAULT, MAP_STYLE_SATELLITE} from "@/config/const";

const _MAP_DEFAULT_STYLE_URL = "mapbox://styles/aidea/ckkyrc2lg2nm317pbxxn1cggh"
const _MAP_SATELLITE_STYLE_URL = "mapbox://styles/aidea/ckq7ded3v5onl17pjqoo30sl8"

const MAPBOX_STYLES = [
  {id: 1, url: _MAP_DEFAULT_STYLE_URL, name: "標準地図", img: require("@/assets/images/mapStyle/defaultMap.png")},
  {id: 2, url: _MAP_SATELLITE_STYLE_URL, name: "航空写真", img: require("@/assets/images/mapStyle/sattelliteMap.png")}
]

export default {
  data() {
    return {
      mapStyleList: MAPBOX_STYLES,
      MAP_DEFAULT_STYLE_URL: _MAP_DEFAULT_STYLE_URL,
      MAP_SATELLITE_STYLE_URL: _MAP_SATELLITE_STYLE_URL
    };
  },
  methods: {
    async getUsersMapStyle() {
      let style = await LocalDbService.getMapStyle()
      return style
    },
    async saveUsersMapStyle(id) {
      let style = MAPBOX_STYLES.find(v => {
        return v.id === id
      })
      await FireStoreService.saveMapStyle(style.url);
      await LocalDbService.saveMapStyle(style.url);
    },
    isDefaultMapStyle(mapUrl) {
      return mapUrl === _MAP_DEFAULT_STYLE_URL
    },
    convertToNewStyleMap(mapUrl) {
      if (mapUrl === MAP_STYLE_DEFAULT) {
        return _MAP_DEFAULT_STYLE_URL
      } else if (mapUrl === MAP_STYLE_SATELLITE) {
        return _MAP_SATELLITE_STYLE_URL
      }else {
        return mapUrl
      }
    },
  }
}
